import React from 'react';
import { get, debounce } from 'lodash';
import { decodeQuery } from '@wix/communities-blog-client-common';
import HeaderWidget from '../../../common/components/header-widget';
import { connect } from '../../../common/components/runtime-context';
import SearchInput from '../../../common/components/search-input';

const DEBOUNCE_WAIT = 500;

type Props = {
  component: React.ElementType;
  left?: React.ReactNode;
  query?: string;
  inputClassName?: string;
  iconClassName?: string;
  borderClassName?: string;
  showWidget?: boolean;
  navigateToSearch: (query: string) => void;
};

const SearchHeader = ({
  component: Component,
  left,
  query,
  inputClassName,
  iconClassName,
  borderClassName,
  showWidget = true,
  navigateToSearch,
  ...props
}: Props) => {
  const handleQueryChange = debounce(
    (nextQuery: string) => navigateToSearch(nextQuery),
    DEBOUNCE_WAIT,
  );

  const searchInput = (
    <SearchInput
      isExpanded
      isFullWidth={!showWidget}
      value={query}
      onChange={handleQueryChange}
      inputClassName={inputClassName}
      iconClassName={iconClassName}
      borderClassName={borderClassName}
    />
  );

  return (
    <Component
      left={left}
      right={showWidget ? <HeaderWidget searchInput={searchInput} /> : searchInput}
      {...props}
    />
  );
};

type OwnProps = {
  params?: { query?: string };
};

import { type Actions, type AppState } from '../../../common/types';

const mapRuntimeToProps = (_state: AppState, ownProps: OwnProps, actions: Actions) => ({
  query: decodeURIComponent(decodeQuery(get(ownProps, 'params.query', ''))),
  navigateToSearch: actions.navigateToSearch,
});

export default connect(mapRuntimeToProps)(SearchHeader);
